<template>
    <div name="recent" style="width: 100%;">
        <confirm-modal 
            :title="'최근 검색어를 모두 삭제하시나요?'"
            :text1="`삭제하면 검색어 기록이 모두 사라져요.`"
            :text2="''"
            @onYes="onConfirmModalYes"
            @onCancel="onConfirmModalCancel"
            v-if="isConfirmModal"
        />
        <div class="tabs">
            <span class="active-tab-text">최근 검색어</span>
            <span class="inactive-tab-text" @click="tabChange" style="margin-left: 16px;">상품유형 검색</span>
        </div>
        <div class="line"></div>
        <div class="recent-list">
            <div class="row" style="justify-content: flex-end;">
                <span class="delete-all-button" @click="deleteAllKeyword" v-if="recentSearchKeywords.length > 0">전체 삭제</span>
            </div>
            <div class="row" style="margin-top: 20px;" :key="index" v-for="(keyword, index) in recentSearchKeywords">
                <span @click="searchKeyword(keyword)" class="keyword-text">{{keyword}}</span>
                <img style="cursor: pointer;" src="../../../../assets/close_gray.png" @click="deleteKeyword(index)" />
            </div>
            
        </div>
    </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';
import ConfirmModal from '@/components/modals/calculator/ConfirmModal';

export default {
    name: 'recent',
    data: function()
    {
        return {
            recentSearchKeywords: [],
            isConfirmModal: false,
        }
    },
    components: {
        ConfirmModal
    },
    mounted: function()
    {
        const searchKeywords = cookies.getLocalStorage("search_keyword");
        // alert(searchKeywords)
        if(searchKeywords === null || searchKeywords === undefined || searchKeywords === '')
        {
          
        }
        else
        {
            this.recentSearchKeywords = searchKeywords.split(',');
        }
        // cookies 사용 검색어 리스트 읽기
    },
    methods: {
        onConfirmModalYes: function()
        {
            this.isConfirmModal = false;
            this.recentSearchKeywords = [];
            cookies.deleteLocalStorage("search_keyword");
        },
        onConfirmModalCancel: function()
        {
            this.isConfirmModal = false;
        },
        searchKeyword: function(keyword)
        {
            this.$emit('searchRecent', keyword.trim())
        },
        deleteAllKeyword: function()
        {
            this.isConfirmModal = true;
        },
        deleteKeyword: function(index)
        {
            this.recentSearchKeywords.splice(index, 1);
            // list 삭제
            // cookie 저장
            let saveKeywords = "";
            this.recentSearchKeywords.forEach(data => {
                saveKeywords += `${data},`
            })

            saveKeywords = saveKeywords.substring(0, saveKeywords.length - 1);
            cookies.setLocalStorage("search_keyword", `${saveKeywords}`);
        },
        tabChange: function()
        {
            this.$emit('tabChange', 1)
        }
    }
}
</script>

<style scoped>
    .active-tab-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .inactive-tab-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .tabs {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #EDEEF0;
    }
    .line {
        background: #1E1E1E;
        width: 84px;
        height: 1.5px;
        margin-left: 16px;
    }
    .recent-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20px 16px;
        box-sizing: border-box;
    }
    .row {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .delete-all-button {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 94.444% */
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        cursor: pointer;
    }
    .keyword-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 94.444% */
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/calculator/rare/Recent.vue